//node_modules
import React, { FunctionComponent } from "react";
import NextLink from "@adjust/website/src/components/NextLink";
import { Pagination } from "react-bootstrap";

//hooks
import usePaginationContext from "../hooks/usePaginationContext";

const LastComponent: FunctionComponent = () => {
  const handler = usePaginationContext();

  if (handler.disabled(handler.getPageCount())) {
    return <Pagination.Last disabled={true} />;
  }

  return (
    <NextLink href={handler.generatePath(handler.getPageCount())}>
      <Pagination.Last />
    </NextLink>
  );
};

export default React.memo(LastComponent);
